import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditAcademicYear from '../../components/academicYears/FormAddEditAcademicYear';
import { useParams } from 'react-router-dom';
import { useGetAcademicYear } from '../../hooks/academicYears/useGetAcademicYear';
import LoadingPage from '../../components/global/LoadingPage';

const EditAcademicYear = () => {
    const { id } = useParams();
    const { academicYear, isLoading } = useGetAcademicYear(id);

    if (isLoading) return <LoadingPage />;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAcademicYear isEdit currentData={academicYear?.data} />
        </WrapperSection>
    );
};

export default EditAcademicYear;
